<template> 
	<div class="whitebox company-tags	centerpage ">
		<div class=" d_blocktitle d-floortitle">
			<i class="title-icon title-icon3"></i>
			<h3 class="title">{{title}}</h3>
		</div>
		<div class="equitypledge w95mg">
			<div v-show="isipo">
				<h4  class="endsm_title" v-show="pledgedata1.pledgeRatio!=undefined">质押比例</h4>
				<p class="companyinfor oh" v-show="pledgedata1.pledgeRatio!=undefined"> 
	<!-- 			id: 1
				importantShareholderPledgeCount: 3
				industry: "光学光电子"
				lastYearScore: "-20.75%"
				limitSaleNum: "0"
				pledgeDetailCount: 26
				pledgeRatio: "2.48%"
				pledgeShareNum: "4.24亿"
				pledgeTransNum: "13"
				pledgeValue: "18.86亿"
				unlimitSaleNum: "4.24亿"
 -->
				
					<span class="fl"><i>股票代码：</i><em>{{stockcode}}</em></span> 
					<span class="fl"><i>股票简称：</i><em>{{companyname}}</em></span> 
					<span class="fl"><i>质押比例：</i><em>{{pledgedata1.pledgeRatio}}</em></span>
					<span class="fl"><i>质押股数（股）：</i><em>{{pledgedata1.pledgeShareNum}}</em></span> 
					<span class="fl"><i>质押市值（元）：</i><em>{{pledgedata1.pledgeValue}}</em></span> 
					<span class="fl"><i>质押笔数：</i><em>{{pledgedata1.pledgeTransNum}}</em></span> 
					<span class="fl"><i>无限售股质押数（股）：</i><em>{{pledgedata1.unlimitSaleNum}}</em></span> 
					<span class="fl"><i>限售股质押数（股）：</i><em>{{pledgedata1.limitSaleNum}}</em></span> 
					<span class="fl"><i>	近一年涨跌幅：</i><em>{{pledgedata1.lastYearScore}}</em></span> 
					<span class="fl"><i>所属行业：</i><em>{{pledgedata1.industry}}</em></span> 
					</p>
				<h4 class="endsm_title" v-show="blockdata.pledgeShareholder.length>0">重要股东质押统计</h4>
				<table border="0" cellspacing="0" cellpadding="0"   class="pagetable1" width="100%" v-show="blockdata.pledgeShareholder.length>0">
						<tr>
							<th class="xuhaotd">序号</th> 
							<th>股东名称</th>
							<th>最高质押笔数</th>
							<th>剩余质押股数（股）</th>
							<th>更新日期</th>
						</tr>
						<tr v-for="(list,i) in blockdata.pledgeShareholder">
							<td>{{i+1}}</td>
							<td>{{list.shareholderName}}</td>
							<td>{{list.maxPledgeNum}}</td>
							<td>{{list.remainPledgeNum}}</td>
							<td>{{list.updateDate}}</td>
						</tr>
				</table>
				<h4 class="endsm_title"v-show="blockdata.pledgeDetail.length>0">质押明细</h4> 
			</div>
			<table border="0" cellspacing="0" cellpadding="0"   class="pagetable1" width="100%" v-show="blockdata.pledgeDetail.length>0">
				<tr>   
					<th class="xuhaotd">序号</th>
					<th>质押人	</th>
					<th>质押人参股企业</th>
					<th>质押权人</th>
					<th>质押股份总数（股）</th>
					<th>质押股份市值（元）</th>
					<th>状态</th>
					<th>公告日期</th>
				</tr>
				<tr v-for="(list,i) in blockdata.pledgeDetail">
					<td>{{i+1}}</td>
					<td>{{list.pledgePerson}}</td>
					<td>{{list.pledgePersonInvestEnterprise}}</td>
					<td>{{list.pledgee}}</td>
					<td>{{list.pledgeTotalNum}}</td>
					<td>{{list.pledgeValue}}</td>
					<td>{{list.pledgeStatus}}</td>
					<td>{{list.publishDate}}</td>
				</tr>
			</table> 
		</div> 
	</div> 
</template>

<script>
	export default {
	  name: 'equitypledge', 
			data() {
				return {
					titleh:"股权质押",
			  pledgedata1:{},
			}},
	  props: { 
					title: String,hasdata:Boolean,
					isipo:Boolean,
					stockcode:String,companyname:String,
					blockdata:{
						type:Object,default:true
					},
	  }, 
			mounted() {
				if(this.blockdata.stockPledge.length>0){
					this.pledgedata1=this.blockdata.stockPledge[0];
				}else{
					this.pledgedata1={};
				}
				  
				 // console.log('pledgedata1',this.pledgedata1)
			}
	}
</script>

<style > 
.enterprise_detail .equitypledge .companyinfor i{
	width: 180px;
}
.enterprise_detail .equitypledge .companyinfor {
	padding-left: 0;margin-bottom: 20px;
}
	  .endsm_title{
			font-size: 16px; line-height: 42px; margin-bottom: 10px; 
		}
		.mgtn{
			margin-top: 0 !important;
		}
</style>